import { TIPO } from "constants/tiposDoc"

export const SERVICOSTAXAS =
[
    {
        tipoServico: "Protocolo",
        servicos: [
        {
            id: "Protocolo",
            nome: "Protocolo de Entrada",
            taxaFixa: false
        }
        ]
    },
    {
        tipoServico: "Alvarás",
        servicos: [
        {
            id: "Alvara",
            nome: "Alvará de Construção",
            taxaFixa: false,
            docGerado: TIPO.Alvara
        },
        {
            id: "AlvaraAcresReg",
            nome: "Alvará de Construção com Acréscimo / Reforma e Regularização",
            taxaFixa: false,
            docGerado: TIPO.Alvara
        },
        {
            id: "SubsProj",
            nome: "Substituição de Projeto",
            taxaFixa: false,
            docGerado: TIPO.Alvara
        },
        {
            id: "RenAlvara",
            nome: "Renovação de Alvará",
            taxaFixa: false,
            docGerado: TIPO.Alvara
        }
        ]
    },
    {
        tipoServico: "Anuências",
        servicos: [
        {
            id: "Anuencia",
            nome: "Anuência Prévia",
            taxaFixa: false,
            docGerado: TIPO.Anuencia
        }
        ]
    },
    {
        tipoServico: "Autorizações",
        servicos: [
        {
            id: "AutDemol",
            nome: "Autorização de Demolição",
            taxaFixa: false,
            docGerado: TIPO.AutDemol
        },
        {
            id: "AutObrasInfra",
            nome: "Autorização de Obras de Infraestrutura",
            taxaFixa: false,
            docGerado: TIPO.AutObrasInfra
        },
        {
            id: "AutRepGerais",
            nome: "Autorização de Reparos Gerais",
            taxaFixa: false,
            docGerado: TIPO.AutRepGerais
        },
        {
            id: "AutRepGeraisAcess",
            nome: "Autorização de Reparos Gerais de Acessibilidade",
            taxaFixa: false,
            docGerado: TIPO.AutRepGeraisAcess
        },
        {
            id: "AutERB",
            nome: "Autorização para Instalação de ERB",
            taxaFixa: false,
            docGerado: TIPO.AutERB
        }
        ]
    },
    {
        tipoServico: "Certidões",
        servicos: [
        {
            id: "CertLaudoVist",
            nome: "Certidão de Laudo de Vistoria",
            taxaFixa: false,
            docGerado: TIPO.CertLaudoVist
        },
        {
            id: "CertDemolComAut",
            nome: "Certidão de Demolição com Autorização",
            taxaFixa: true,
            docGerado: TIPO.CertDemol
        },
        {
            id: "CertHabitese",
            nome: "Certidão de Habite-se",
            taxaFixa: false,
            docGerado: TIPO.Habitese
        },
        {
            id: "CertRegul",
            nome: "Certidão de Regularização",
            taxaFixa: false,
            docGerado: TIPO.CertRegul
        },
        {
            id: "CertRegulInfra",
            nome: "Certidão de Regularização para obra de Infraestrutura",
            taxaFixa: false,
            docGerado: TIPO.CertRegulInfra
        },
        {
            id: "CertRetEndNum",
            nome: "Certidão de Retificação de Endereço e Número",
            taxaFixa: false
        },
        {
            id: "CertUsoOcup",
            nome: "Certidão de Uso e Ocupação do Solo",
            taxaFixa: true,
            docGerado: TIPO.CertUsoOcupSolo
        },
        {
            id: "CertUsoOcupDir",
            nome: "Certidão de Uso e Ocupação do Solo e Diretrizes",
            taxaFixa: true,
            docGerado: TIPO.CertUsoOcupSoloDir
        },
        {
            id: "RenHabitese",
            nome: "Habite-se fora do prazo",
            taxaFixa: false,
            docGerado: TIPO.Habitese
        }
        ]
    },
    {
        tipoServico: "Declarações",
        servicos: [
        {
            id: "DeclAtendTermoCompr",
            nome: "Declaração de Atendimento a Termo de Compromisso",
            taxaFixa: false,
            docGerado: TIPO.DeclAtendTermoCompr
        },
        {
            id: "DeclConcInstERBComAut",
            nome: "Declaração de Conclusão de Instalação de ERB com Autorização",
            taxaFixa: false,
            docGerado: TIPO.DeclInstERB
        },
        {
            id: "DeclConcInstERBSemAut",
            nome: "Declaração de Conclusão de Instalação de ERB sem Autorização",
            taxaFixa: false,
            docGerado: TIPO.DeclInstERB
        },
        {
            id: "DeclConcObrasInfra",
            nome: "Declaração de Conclusão de Obras de Infraestrutura",
            taxaFixa: false,
            docGerado: TIPO.DeclConcObrasInfra
        },
        {
            id: "DeclConcRepGerais",
            nome: "Declaração de Conclusão de Reparos Gerais",
            taxaFixa: true,
            docGerado: TIPO.DeclRepGerais
        },
        {
            id: "DeclConcRepGeraisAcess",
            nome: "Declaração de Conclusão de Reparos Gerais de Acessibilidade",
            taxaFixa: true,
            docGerado: TIPO.DeclRepGeraisAcess
        },
        {
            id: "DeclGLP",
            nome: "Declaração de GLP",
            taxaFixa: false,
            docGerado: TIPO.DeclGLP
        },
        {
            id: "DeclNumPorta",
            nome: "Declaração de Número de Porta",
            taxaFixa: false,
            docGerado: TIPO.DeclNumeroPorta
        }
        ]
    },
    {
        tipoServico: "Fiscalização - emissão de multas",
        servicos: [
        {
            id: "AutoDeEmbargo",
            nome: "Prosseguimento de obra embargada",
            taxaFixa: false
        },
        {
            id: "AutoDeInfracao",
            nome: "Laudo de vistoria - Auto de Infração",
            taxaFixa: false
        },
        {
            id: "ObraIniciadaSemLicenca",
            nome: "Obra Iniciada sem Licença",
            taxaFixa: false
        },
        {
            id: "ReparosGeraisSemLicenca",
            nome: "Reparos Gerais Iniciados sem Licença",
            taxaFixa: false
        },
        {
            id: "CertDemolSemAut",
            nome: "Certidão de Demolição sem Autorização",
            taxaFixa: false,
            docGerado: TIPO.CertDemol
        }
        ]
    },
    {
        tipoServico: "Termos",
        servicos: [
        {
            id: "TermoDemarc",
            nome: "Termo de Demarcação",
            taxaFixa: false,
            docGerado: TIPO.TermoDemarc
        },
        {
            id: "TermoDesm",
            nome: "Termo de Desmembramento",
            taxaFixa: false
            // docGerado: termoLoteOuGleba
        },
        {
            id: "TermoRem",
            nome: "Termo de Remembramento",
            taxaFixa: false,
            docGerado: TIPO.TermoRem
        },
        {
            id: "TermoDesmRem",
            nome: "Termo de Remembramento / Desmembramento ",
            taxaFixa: false,
            docGerado: TIPO.TermoRemDesm
        },
        {
            id: "TermoDesmComIncorporacao",
            nome: "Termo de Desmembramento com Incorporação",
            taxaFixa: false
            // docGerado: termoLoteOuGleba
        },
        {
            id: "TermoVerObras",
            nome: "Termo de Verificação de Obras",
            taxaFixa: false,
            docGerado: TIPO.TermoVerObras
        }
        ]
    }
]

export const semTaxaProtocolo =
[
    "AutoDeEmbargo",
    "AutoDeInfracao",
    "ObraIniciadaSemLicenca",
    "ReparosGeraisSemLicenca",
    "AutObrasInfra",
    "CertDemolComAut",
    "CertUsoOcup",
    "CertUsoOcupDir",
    "DeclConcRepGerais",
    "DeclConcRepGeraisAcess",
    "Protocolo",
    "TermoDemarc"
]

export const comTipoUso = 
[
    "Alvará de Construção",
    "Alvará de Construção com Acréscimo / Reforma e Regularização",
    "Substituição de Projeto",
    "Renovação de Alvará",
    "Anuência Prévia",
    "Autorização de Reparos Gerais",
    "Autorização de Reparos Gerais de Acessibilidade",
    "Certidão de Laudo de Vistoria",
    "Certidão de Regularização",
    "Certidão de Habite-se",
    "Renovação de Habite-se"
]

// function termoLoteOuGleba(areaTerreno) { return Number(areaTerreno) <= 40000 ? TIPO.TermoDesmLote : TIPO.TermoDesmGleba}